import React, { Component } from 'react';

class TwitterIcon extends Component {


    render() {

        let width = this.props.width || "24px";
        let height = this.props.height || "20px";

        return (
        <svg width={width} height={height} viewBox="0 0 24 20" version="1.1" xmlSpace="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink">
            <title>twitter</title>
            <desc>Created with Sketch.</desc>
            <defs></defs>
            <g id="Homepage" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" >
                <g id="Homepage-3" transform="translate(-394.000000, -2815.000000)" fill="#00ACED">
                    <g id="Section-5" transform="translate(0.000000, 2650.000000)">
                        <g id="twitter-+-Tweet" transform="translate(363.000000, 156.000000)">
                            <g transform="translate(31.000000, 9.000000)" id="twitter">
                                <path d="M24.0546875,2.75810975 C23.1640625,3.15654725 22.2265625,3.4260785 21.21875,3.543266 C22.25,2.933891 23.0234375,1.96123475 23.3867188,0.812797249 C22.4492188,1.37529725 21.3828125,1.7854535 20.28125,2.00810975 C19.3554688,1.07060975 18.078125,0.461234749 16.6601562,0.461234749 C13.9414062,0.461234749 11.75,2.652641 11.75,5.371391 C11.75,5.75810975 11.7734375,6.15654725 11.8554688,6.50810975 C7.77734375,6.2854535 4.16796875,4.433891 1.71875,1.4573285 C1.30859375,2.183891 1.05078125,2.933891 1.05078125,3.8479535 C1.05078125,5.5354535 1.91796875,7.0354535 3.25390625,7.9260785 C2.4453125,7.902641 1.6953125,7.67998475 1.02734375,7.3167035 L1.02734375,7.37529725 C1.02734375,9.76592225 2.7265625,11.7581097 4.9765625,12.2034222 C4.5546875,12.3206097 4.109375,12.3792035 3.6640625,12.3792035 C3.359375,12.3792035 3.0546875,12.3440472 2.75,12.2854535 C3.359375,14.230766 5.19921875,15.683891 7.33203125,15.7073285 C5.66796875,17.043266 3.5234375,18.0393597 1.2265625,18.0393597 C0.828125,18.0393597 0.44140625,18.0159222 0.0546875,17.9573285 C2.22265625,19.3518597 4.8359375,19.9612347 7.61328125,19.9612347 C16.6601562,19.9612347 21.6054688,12.4612347 21.6054688,5.9573285 L21.6054688,5.31279725 C22.5546875,4.621391 23.3867188,3.76592225 24.0546875,2.75810975 L24.0546875,2.75810975 Z"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
        );
    }

}


export default TwitterIcon;
